export default __webpack_public_path__ + "static/media/hotel.a3e4e7a3.png";